import { get, reduce } from 'lodash';

import { CalculationService } from '@app/shared/services/stand-worksheet/calculation-services/calculation.types';
import {
  IStandWorkSheetItem,
  IStandWorkSheetItemFullData,
} from '@app/shared/types/entities/stand-worksheet/stand-worksheet.type';

const createStandWorksheetItemsMap = (
  standWorksheetItems: IStandWorkSheetItem[],
  swCalculationService: CalculationService,
): IStandWorkSheetItem => {
  return reduce(
    standWorksheetItems,
    (resultMap, item) => {
      const totalAvailable = swCalculationService.calculateTotalAvailableColumn(
        item as IStandWorkSheetItemFullData,
      );

      return {
        ...resultMap,
        [item.inventory_item_entity_id]: {
          expected_qty: swCalculationService.calculateExpectedQuantityColumn(
            item as IStandWorkSheetItemFullData,
            totalAvailable,
          ),
          end: get(item, 'end', 0),
        },
      };
    },
    {} as IStandWorkSheetItem,
  );
};

export { createStandWorksheetItemsMap };
